module.exports = __webpack_public_path__ + "static/media/activation-home-android.cdf20003.webp";